import { ComponentType } from 'react';
import { Icon } from '@internal/ui';

/**
 * Backstage's IconComponent passes MUI's named `fontSize`; sidebar items pass
 * `inherit` and size the icon from their own box.
 */
type BackstageIconProps = {
  fontSize?: 'small' | 'medium' | 'large' | 'inherit';
};

const SIZE_PX: Record<
  NonNullable<BackstageIconProps['fontSize']>,
  number | '1em'
> = {
  small: 16,
  medium: 20,
  large: 24,
  inherit: '1em',
};

export const materialIcon = (
  name: string,
): ComponentType<BackstageIconProps> => {
  const Adapted = ({ fontSize = 'medium' }: BackstageIconProps) => (
    <Icon name={name} size={SIZE_PX[fontSize]} />
  );
  Adapted.displayName = `MaterialIcon(${name})`;
  return Adapted;
};

/** Replaces the app's default MUI icon set; keys from plugin-app's defaults/icons. */
export const PRIMARY_ICONS = {
  brokenImage: materialIcon('broken_image'),
  catalog: materialIcon('category'),
  scaffolder: materialIcon('add_circle_outline'),
  techdocs: materialIcon('article'),
  search: materialIcon('search'),
  chat: materialIcon('chat_bubble_outline'),
  dashboard: materialIcon('dashboard'),
  docs: materialIcon('article'),
  email: materialIcon('mail_outline'),
  group: materialIcon('group'),
  help: materialIcon('help_outline'),
  'kind:api': materialIcon('api'),
  'kind:component': materialIcon('memory'),
  'kind:domain': materialIcon('domain'),
  'kind:group': materialIcon('group'),
  'kind:location': materialIcon('place'),
  'kind:system': materialIcon('hub'),
  'kind:user': materialIcon('person_outline'),
  'kind:resource': materialIcon('storage'),
  'kind:template': materialIcon('description'),
  user: materialIcon('person_outline'),
  warning: materialIcon('warning_amber'),
  star: materialIcon('star'),
  unstarred: materialIcon('star_border'),
  externalLink: materialIcon('open_in_new'),
};
